var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"20px"}},[_c('el-button',{attrs:{"loading":_vm.downloadLoading,"type":"primary","size":"medium","icon":"el-icon-document"},on:{"click":_vm.handleDownload}},[_vm._v(" 导出身份信息表 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }